<template>
  <div class="external-consent-notice">
    <p>{{ message }}</p>
    <button type="button" class="button light" @click="openCookieSettings">
      Cookie-Einstellungen
    </button>
  </div>
</template>

<script>
import { useCookieConsent } from '../../composables/useCookieConsent.js'

export default {
  name: 'ExternalServiceConsentNotice',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { openCookieSettings } = useCookieConsent()
    return { openCookieSettings }
  },
}
</script>
